
<template>
  <div>
    <DxDataGrid
      :columns="itemHeaders"
      :summary="summary"
      :data-source="lineItems.items"
      :show-borders="true"
      :allow-column-resizing="true"
      :showRowLines="true"
      key-expr="id"
      :toolbar="toolbar"
      @cell-prepared="onCellPrepared"
      :ref="itemDataGridRefKey"
      :onCellClick="handleCellClick"
      @focused-cell-changed="onFocusCellChanged"
      @content-ready="onContentReady"
    >
      <DxEditing
        :allow-updating="true"
        :allow-deleting="true"
        start-edit-action="click"
        mode="batch"
        :select-text-on-edit-start="true"
        :new-row-position="newRowPosition"
        :use-icons="true"
      />

      <template #cstm-field="{ data: cellData }">
        <div>
          <custom-field-types-list
            :item="cellData"
            :on-value-changed="cellData.setValue"
            :prefix="slug"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          >
          </custom-field-types-list>
        </div>
      </template>
      <template #rlt-field-show="{ data: cellData }">
        <div>
          <relate-show
            :cellData="cellData"
            :prefix="slug"
            :currentRoute="cellData.columnIndex"
            :fieldDef="itemHeaders[cellData.columnIndex]"
          >
          </relate-show>
        </div>
      </template>

      <template #batch_dialog_field="{ data: cellData }">
        <div>
          <BatchDialogField
            :cellData="cellData"
            @onBatchSave="handleBatchSave"
            :modelValue="cellData.rlt_cnslinventorydetail_cnslbatchdetail"
          />
        </div>
      </template>
    </DxDataGrid>

    <div class="grid grid-cols-2 gap-4">
      <div class="line-add-button">
        <DxButton
          text="Add"
          type="normal"
          icon="plus"
          styling-mode="contained"
          @click="addNewRow()"
        />
      </div>
      <div class="">
        <DxDataGrid
          :columns="ledgerHeaders"
          :data-source="lineItems.ledgers"
          :summary="legderSummary"
          :show-borders="true"
          :allow-column-resizing="true"
          :showRowLines="true"
          key-expr="id"
          :toolbar="toolbar"
          @cell-prepared="onCellPreparedLdgr"
          :ref="ledgerDataGridRefKey"
          @focused-cell-changed="onFocusCellChanged"
        >
          <DxEditing
            :allow-updating="true"
            :allow-deleting="true"
            mode="batch"
            start-edit-action="click"
            :new-row-position="newRowPosition"
            :use-icons="true"
          >
          </DxEditing>
          <template #rlt-field="{ data: cellData }">
            <!-- <RltField :cell-data="cellData"></RltField> -->
          </template>
          <template #cstm-field="{ data: cellData }">
            <div>
              <custom-field-types-list
                :item="cellData"
                :on-value-changed="cellData.setValue"
                :prefix="slug"
                :fieldDef="ledgerHeaders[cellData.columnIndex]"
              >
              </custom-field-types-list>
            </div>
          </template>
          <template #rlt-field-show="{ data: cellData }">
            <div>
              <relate-show
                :value="cellData.value"
                :on-value-changed="cellData.setDisplayValue"
                :cellData="cellData"
                :prefix="slug"
                :fieldDef="ledgerHeaders[cellData.columnIndex]"
              >
              </relate-show>
            </div>
          </template>
        </DxDataGrid>
        <div class="line-add-button">
          <div class="flex">
            <div class="flex-none">
              <DxButton
                text="Add"
                type="normal"
                icon="plus"
                styling-mode="contained"
                @click="addLedgerRow()"
              />
            </div>
            <div class="flex-1 ml-1">
              <DxDataGrid
                :columns="totalCol"
                :show-borders="false"
                :allow-column-resizing="true"
                :show-row-lines="false"
                :show-column-lines="false"
                :data-source="grandTotalData"
                :show-column-headers="false"
              >
                <template #bold="{ data: { value } }">
                  <span :style="{ fontWeight: 'bold' }">{{ value }}</span>
                </template>
              </DxDataGrid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";
import DxButton from "devextreme-vue/button";
import Guid from "devextreme/core/guid";
import DxDateBox from "devextreme-vue/date-box";
import CustomFieldTypesList from "./CustomFieldTypesforList.vue";
import RelateShow from "./line_item/ListRelateFieldShow.vue";
import { getInvoiceFieldDef } from "../Pages/Builder/base.js";
import CustomStore from "devextreme/data/custom_store";
import { isProxy, isArrayProxy, isProxy1 } from "./builder/base.js";
import BatchDialogField from "@/components/BatchDialogComponent.vue";

const itemDataGridRefKey = "itemDataGrid";
const ledgerDataGridRefKey = "ledgerDataGrid";
let sTotal = 0;

export default {
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    def: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    slug: String,
    defaultData: {
      type: Array,
      default: [],
    },
    partyLedgerId: String,
    fname: String,
    modRoute: String,
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxButton,
    DxDateBox,
    CustomFieldTypesList,
    RelateShow,
    BatchDialogField,
  },
  data() {
    return {
      itemDataGridRefKey,
      ledgerDataGridRefKey,
      sTotal,
      lineItems: {
        items: [],
        ledgers: [],
        partyLadger: {},
        otherLedgers: [],
      },
      itemHeaders: [],
      ledgerHeaders: [],
      LineCount: 2,
      dataSource: [],
      count: 1,
      showBorders: true,
      showRowLines: true,
      newRowPosition: "last",
      productRoute: "cnsl-products",
      changes: [],
      editRowKey: null,
      summary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
          },
        ],
      },
      legderSummary: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            column: "Amount",
            summaryType: "sum",
            displayFormat: "Total: {0}",
            showInColumnFooter: false,
          },
        ],
      },
      legderSummary1: {
        recalculateWhileEditing: true,
        totalItems: [
          {
            name: "SelectedRowsSummary",
            showInColumn: "Amount",
            showSummary: "false",
            summaryType: "custom",
            displayFormat: "Grand Total: {0}",
          },
        ],
        calculateCustomSummary(options) {
          if (options.name === "SelectedRowsSummary") {
            if (options.summaryProcess === "start") {
              options.totalValue = sTotal;
            }
            if (options.summaryProcess === "calculate") {
              //if (options.component.isRowSelected(options.value.ID)) {
              options.totalValue += options.value.Amount;
              //}
            }
          }
        },
      },
      totalCol: [
        {
          dataField: "GrandTotal",
          cellTemplate: "bold",
          alignment: "right",
        },
        {
          dataField: "value",
          width: 100,
          cellTemplate: "bold",
        },
        {
          type: "empty",
          width: 40,
        },
      ],

      grandTotalData: [
        {
          GrandTotal: "Grand Total:",
          value: 0,
        },
      ],
      toolbar: {
        visible: false,
      },
    };
  },
  methods: {
    makeAsyncDataSource(rRoute, slug) {
      return new CustomStore({
        key: "id",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/list";
          var parameters = {};
          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }

          var config = {
            params: parameters,
          };
          return axios
            .get(listurl, config)
            .then((response) => {
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
          let url = "/" + slug + "/" + rRoute + "/getById/" + key;
          let data = {};
          //const response = await getRecordByIdasync(url);

          //return response.data;
        },
      });
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      $.each(toolbarItems, function (_, item) {
        if (item.name == "saveButton" || item.name == "revertButton") {
          item.visible = false;
        }
      });
    },
    addNewRow() {
      this.itemDataGrid.addRow();
    },
    addLedgerRow() {
      this.ledgerDataGrid.addRow();
    },
    getGrandTotal(options) {
      if (options.name === "SelectedRowsSummary") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        }
        if (options.summaryProcess === "calculate") {
          if (options.component.isRowSelected(options.value.ID)) {
            options.totalValue += options.value.SaleAmount;
          }
        }
      }
    },
    save() {
      this.itemDataGrid.saveEditData();
      this.ledgerDataGrid.saveEditData();
    },

    handleCellClick(e) {
      console.log("Cell clicked: ", e.column.dataField);
    },
    onFocusCellChanged(e) {
      this.save();
      this.$emit("update:modelValue", this.lineItems);
    },

    onCellPrepared(e) {
      console.log("onCellPrepared called");
      /* if (e.rowType === 'data' && e.column.command === "edit")
             {
                console.log("prepared ",e);
             } */
      if (e.row) {
        var visibleRows = e.component.getVisibleRows();
        var row = visibleRows[e.row.rowIndex];

        if (row && row.type === "deleted") {
          // The row has been deleted
          // Add your custom code here
          //console.log("del");
        } else {
          // The row is visible and has not been deleted
          // Add your custom code here
          //console.log("pass");
        }
      }

      if (e.rowType === "data" && e.column.allowEditing) {
        if (
          e.column.dataField == "cnsl_product_id" ||
          e.column.dataField == "product_id"
        ) {
          console.log("e.column Field LineItems ", e);
          if (e.value != undefined) {
            if (e.column.dataField == "product_id") {
              this.productRoute = "products";
            }

            let url =
              "/" + this.slug + "/" + this.productRoute + "/getById/" + e.value;
            return axios
              .get(url)
              .then((response) => {
                console.log("Inv Product Change Response", response.data.data);
                this.lineItems.items[e.rowIndex].hsn = response.data.data.hsn;
                this.lineItems.items[e.rowIndex].gst_rate =
                  response.data.data.gst_rate;

                console.log("Inv Product TEST lineItems", this.lineItems);

                // response.data.data.name;
              })
              .catch((error) => {
                console.error("Error fetching dependent value:", error);
                // Optionally, you can throw the error to propagate it to the caller
                throw error;
              });
          }
        }

        e.cellElement.addEventListener("change", (event) => {
          //call save here
          this.save();
          this.addPartyLedger();
          this.addOtherLedger();
          this.$emit("update:modelValue", this.lineItems);

          console.log("Invoice Type Field LineItems ", this.lineItems);

          // Get the new value of the cell
          const newValue = event.target.value;

          // Get the field name of the cell  //also can get editortype
          const fieldName = e.column.dataField;

          // Get the key of the row that was edited
          const rowKey = e.key;

          //console.log(`Cell changed: Row key = ${rowKey}, Field name = ${fieldName}, New value = ${newValue}`);
        });
      }

      if (
        e.rowType === "data" &&
        (e.column.dataField === "Amount" ||
          e.column.dataField === "Quantity" ||
          e.column.dataField === "Rate")
      ) {
        //check if amount not null then only set
        let val = e.data.Quantity * e.data.Rate;
        if (val != null && val != 0) {
          e.data.Amount = e.data.Quantity * e.data.Rate;
        }

        if (e.rowIndex == 0) {
          //this.dataSource[0].Amount = e.data.Quantity * e.data.Rate;
        }
      }
      sTotal = this.itemDataGrid.getTotalSummaryValue("Amount");
      sTotal += this.ledgerDataGrid.getTotalSummaryValue("Amount");

      this.grandTotalData[0].value = sTotal;

      //this.ledgerDataGrid.refresh("Amount");
    },
    onCellPreparedLdgr(e) {
      if (e.rowType === "data" && e.column.allowEditing) {
        e.cellElement.addEventListener("change", (event) => {
          //call save here
          this.save();
          this.addPartyLedger();
          this.addOtherLedger();
          this.$emit("update:modelValue", this.lineItems);

          // Get the new value of the cell
          const newValue = event.target.value;

          // Get the field name of the cell  //also can get editortype
          const fieldName = e.column.dataField;

          // Get the key of the row that was edited
          const rowKey = e.key;

          //console.log(`Cell changed: Row key = ${rowKey}, Field name = ${fieldName}, New value = ${newValue}`);
        });
      }

      if (e.rowType === "data" && e.column.dataField === "Amount") {
      }
      sTotal = this.itemDataGrid.getTotalSummaryValue("Amount");
      sTotal += this.ledgerDataGrid.getTotalSummaryValue("Amount");

      this.grandTotalData[0].value = sTotal;

      //this.ledgerDataGrid.refresh("Amount");
    },
    getFormDef(fname) {
      getInvoiceFieldDef(this.modRoute, fname, false).then((response) => {
        this.itemHeaders = Object.values(response.data.top);
        this.ledgerHeaders = Object.values(response.data.bottom);
      });
    },
    addPartyLedger() {
      // Determine the route type
      const routeType = this.getRouteType();

      // Set the ledger key based on route type
      const ledgerKey =
        routeType === "console" ? "cnsl_ledger_id" : "ledger_id";

      // Initialize partyLedger if it's null
      if (this.lineItems.partyLadger == null) {
        this.lineItems.partyLadger = {};
      }

      // Set the ledger ID and amount using the correct key
      this.lineItems.partyLadger[ledgerKey] = this.partyLedgerId;
      this.lineItems.partyLadger.amount = sTotal;
    },
    addOtherLedger() {
      // Determine the route type
      const routeType = this.getRouteType();

      // Set the ledger key based on route type
      const ledgerKey =
        routeType === "console" ? "cnsl_ledger_id" : "ledger_id";

      // Get line items and other ledgers
      let data1 = this.lineItems.items;
      let grpLdgr = this.lineItems.otherLedgers;

      // Reset amounts in grpLdgr
      grpLdgr = grpLdgr.map((obj) => ({ ...obj, amount: 0 }));

      // Iterate through line items
      data1.forEach((element) => {
        const key = element[ledgerKey]; // Use the correct ledger key
        let amount = element.amount || 0;

        if (key != null) {
          // Check if grpLdgr is empty
          if (Object.keys(grpLdgr).length === 0) {
            grpLdgr.push({ [ledgerKey]: key, amount: 0 });
          } else {
            const index = grpLdgr.findIndex((obj) => obj[ledgerKey] === key);

            if (index !== -1) {
              // Update existing ledger amount
              grpLdgr[index].amount += parseInt(amount, 10);
            } else {
              // Add new ledger
              grpLdgr.push({
                [ledgerKey]: key,
                amount: parseInt(amount, 10),
              });
            }
          }
        }
      });

      // Update other ledgers
      this.lineItems.otherLedgers = grpLdgr;
    },

    test() {
      //console.log("test ho ra");
    },
    addDataSourceInList(data, slug) {
      data = data.map(({ editorType, editorOptions, ...obj }) =>
        editorType === "dxSelectBox" && !obj.lookup
          ? {
              ...obj,
              editorType,
              editorOptions,
              lookup: {
                dataSource: this.makeAsyncDataSource(
                  editorOptions.relateModule,
                  slug
                ),
                valueExpr: "id",
                displayExpr: "name",
              },
            }
          : {
              editorType,
              editorOptions,
              ...obj,
            }
      );

      return data;
    },
    handleBatchSave(batchDetails) {
      var batchData = batchDetails.batchData.data;
      console.log("batchData", batchData);
      console.log("batchData discount", batchData[0].discount);

      var rowIndex = batchDetails.rowIndex;
      // console.log("rowIndex", rowIndex);
      //this.lineItems.items[rowIndex].billed_qty =10;

      // this.lineItems.items[rowIndex].billed_qty = batchData[0].quantity;

      this.lineItems.items[rowIndex].billed_qty =
        this.getTotalBatchQty(batchData);
      this.lineItems.items[rowIndex].rate = batchData[0].rate;
      this.lineItems.items[rowIndex].discount = batchData[0].discount;
      this.lineItems.items[rowIndex].amount =
        this.getTotalBatchAmount(batchData);

      this.lineItems.items[rowIndex].batchDetails = batchData;
      // this.onCellPrepared(e);

      //doing total calculation

      //saveBatchRelation
      // batchDetails
      //this.lineItems.batchDetails = e.data;
    },

    getTotalBatchQty(batchData) {
      let totalQuantity = 0;
      batchData.forEach((item) => {
        //totalAmount += item.amount;
        totalQuantity += item.quantity;
      });

      return totalQuantity;
    },
    getTotalBatchAmount(batchData) {
      let totalAmount = 0;
      console.log("getTotalBatchAmount batchData ", batchData);
      batchData.forEach((item) => {
        if (item.amount !== null && item.amount !== undefined) {
          const amount = parseFloat(item.amount);
          if (!isNaN(amount)) {
            totalAmount += amount;
          }
        }
      });

      return totalAmount;
    },
    onContentReady(e) {
      console.log("onContentReady", e);
      //this.onCellPrepared(e);
    },
    handlePropertyChange(e) {
      console.log("handlePropertyChange", e);
    },
    getRouteType() {
      if (this.modRoute.startsWith("cnsl-")) {
        return "console";
      } else {
        return "general";
      }
    },
  },

  mounted() {
    this.$watch("partyLedgerId,sTotal", (nval, oval) => {
      this.addPartyLedger();
      //console.log("gts",sTotal);
    });

    if (
      (typeof this.modelValue === "object" &&
        Object.keys(this.modelValue).length != 0) ||
      isProxy(this.modelValue)
    ) {
      this.lineItems = this.modelValue;
    }

    //console.log("dsds",this.def.top_view);
    var itemHeadersArray = this.def.top_view;

    console.log("tarun", itemHeadersArray);

    this.itemHeaders = this.addDataSourceInList(itemHeadersArray, this.slug);
    this.ledgerHeaders = this.addDataSourceInList(
      this.def.bottom_view,
      this.slug
    );

    console.log("INVOICE ITEM DDATA", this.itemHeaders);
    console.log("INVOICE ITEM modRoute", this.modRoute);

    //var abc = this.makeAsyncDataSource("cnsl-products","test");

    //this.itemDataGrid.columnOption("cnsl_product_id", "lookup.dataSource", abc);

    //console.log("sds",this.itemDataGrid.getTotalSummaryValue('Amount'));
    this.itemDataGrid.columnOption("command:edit", "width", 40);
    this.ledgerDataGrid.columnOption("command:edit", "width", 40);

    //this.addNewRow() ;

    if (Object.keys(this.modelValue).length === 0) {
      this.itemDataGrid.addRow();
      this.ledgerDataGrid.addRow();
    }
  },
  computed: {
    itemDataGrid: function () {
      return this.$refs[itemDataGridRefKey].instance;
    },
    ledgerDataGrid: function () {
      return this.$refs[ledgerDataGridRefKey].instance;
    },
  },
};
</script>

<style scoped>
</style>